export default {"src":"/_next/static/media/gain-insights.24edb147.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};